var path = 'src/app/users/create-user.html';
var html = "<div page-wrapper> <h1 class=page-header>New User</h1> <div create-user-component></div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/users/create-user.html
 ** module id = 709
 ** module chunks = 0
 **/